export default "__VITE_ASSET__d7af9ea1__"